import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { SvgIcon, IconButton } from '@adsk/bim360-matrix-react-components';

const FilterIcon = props => {
  const { isFilterOpen, toggleFilterPanel } = props;
  const filterPanelButtonClass = cx('FilterIcon', {
    'FilterIcon--active': isFilterOpen,
  });

  return (
    <IconButton onClick={toggleFilterPanel} className={filterPanelButtonClass}>
      <SvgIcon height="12px" width="15px" svgId="funnel-icon" />
    </IconButton>
  );
};

FilterIcon.displayName = 'FilterIcon';

FilterIcon.propTypes = {
  isFilterOpen: PropTypes.bool.isRequired,
  toggleFilterPanel: PropTypes.func.isRequired,
};

export default FilterIcon;
